import { render, staticRenderFns } from "./errormsg.vue?vue&type=template&id=a93b8dac&scoped=true&"
import script from "./errormsg.vue?vue&type=script&lang=js&"
export * from "./errormsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93b8dac",
  null
  
)

export default component.exports